import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const Ctx = createContext(null);

// Capture ?ref= from any page load and persist it 30 days.
function _captureRef() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get("ref") || "").toUpperCase().trim();
    if (!ref) return;
    const now = Date.now();
    localStorage.setItem("agendik_ref", JSON.stringify({ code: ref, at: now }));
  } catch {}
}
function _readRef() {
  try {
    const raw = localStorage.getItem("agendik_ref");
    if (!raw) return "";
    const { code, at } = JSON.parse(raw);
    if (Date.now() - at > 30 * 24 * 3600 * 1000) { localStorage.removeItem("agendik_ref"); return ""; }
    return code || "";
  } catch { return ""; }
}

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("agendik_lang") || "es");
  const [token, setToken] = useState(() => localStorage.getItem("agendik_token") || null);
  const [role, setRole] = useState(() => localStorage.getItem("agendik_role") || null);
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("agendik_user") || "null"); } catch { return null; }
  });
  const [refCode, setRefCode] = useState(() => { _captureRef(); return _readRef(); });

  useEffect(() => { localStorage.setItem("agendik_lang", lang); document.documentElement.lang = lang; }, [lang]);
  useEffect(() => {
    _captureRef();
    setRefCode(_readRef());
  }, []);

  const login = useCallback((tok, r, u) => {
    setToken(tok); setRole(r); setUser(u);
    localStorage.setItem("agendik_token", tok);
    localStorage.setItem("agendik_role", r);
    localStorage.setItem("agendik_user", JSON.stringify(u || null));
  }, []);

  const logout = useCallback(() => {
    setToken(null); setRole(null); setUser(null);
    localStorage.removeItem("agendik_token");
    localStorage.removeItem("agendik_role");
    localStorage.removeItem("agendik_user");
  }, []);

  const clearRef = useCallback(() => { localStorage.removeItem("agendik_ref"); setRefCode(""); }, []);

  const t = translations[lang] || translations.es;

  return (
    <Ctx.Provider value={{ lang, setLang, t, token, role, user, login, logout, setUser, refCode, clearRef }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
